'use client';
import { SerializedEditorState } from 'node_modules/lexical/LexicalEditorState';
import RichText from '../RichText';
import { isValidElement, JSX, ReactNode } from 'react';

export interface CustomRichTextProps {
  data: ReactNode | SerializedEditorState;
  tag: keyof JSX.IntrinsicElements;
  className?: string;
  id?: string;
}
export default function CustomRichText({ data, tag = "div", className = '', id }: CustomRichTextProps) {
  const Tag = tag;

  const isReactNode = (data: unknown): data is ReactNode => {
    if (
      typeof data === 'string' ||
      typeof data === 'number' ||
      typeof data === 'boolean' ||
      data === null ||
      data === undefined ||
      isValidElement(data)
    ) {
      return true;
    }

    if (Array.isArray(data)) {
      return data.every(isReactNode);
    }

    return false;
  };

  return (
    <>
      {isReactNode(data) ? (
        <Tag id={id} className={className}>
          {data}
        </Tag>
      ) : (
          <RichText id={id} data={data} className={`rich-text-container w-auto m-0 ${className}`} />
      )}
    </>
  );
}
